import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Typography
} from '@mui/material'
import PageLoading from '../../../components/PageLoading/PageLoading'
import { sendDailyEmail, sendLeadsDailyEmail } from '../../../utils/api/emails'
import { useNotification } from '../../../context/NotificationManager/NotificationManager'
import FechaSelector from '../../../components/form/FechaSelector/FechaSelector'
import { dateToString } from '../../../utils/date'
import TipoEmailSelector from '../../../components/form/TipoEmailSelector/TipoEmailSelector'
import css from './Emails.module.css'

const Emails = () => {
  const [form, setForm] = useState({ fecha: null, tipo: '' })

  const notification = useNotification()

  const { isPending: isSendingEmail, mutate: enviarEmail } = useMutation({
    mutationFn: ({ tipo, fecha }) =>
      tipo === 'LEADS'
        ? sendLeadsDailyEmail({ fecha })
        : sendDailyEmail({ fecha }),
    onSuccess: () => {
      notification.success({
        title: 'Email enviado',
        content: 'Se ha enviado correctamente'
      })
      setForm({ fecha: null, tipo: '' })
    },
    onError: err => {
      notification.error({ title: 'Error al enviar el email', content: err })
    }
  })

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }))
  }

  const handleSendEmail = e => {
    e.preventDefault()
    if (isSendingEmail || !form.tipo || !form.fecha) return
    const fechaFormateada = dateToString(form.fecha)
    enviarEmail({ tipo: form.tipo, fecha: fechaFormateada })
  }

  return (
    <PageLoading isLoading={isSendingEmail}>
      <Box className={css.wrapper}>
        <Card className={css.card}>
          <CardContent>
            <Typography variant='h5' className={css.title}>
              Enviar Email
            </Typography>
            <form onSubmit={handleSendEmail} className={css.form}>
              <TipoEmailSelector
                className={css.input}
                label='Tipo de email'
                value={form.tipo}
                onChange={e => handleChange('tipo', e.target.value)}
              />
              <FechaSelector
                className={css.input}
                label='Fecha del email'
                value={form.fecha}
                disableFuture
                onChange={value => handleChange('fecha', value)}
              />
              <Button
                variant='contained'
                color='primary'
                disabled={isSendingEmail || !form.fecha || !form.tipo}
                className={css.button}
                onClick={handleSendEmail}
              >
                {isSendingEmail ? (
                  <CircularProgress size={24} color='inherit' />
                ) : (
                  'Enviar'
                )}
              </Button>
            </form>
          </CardContent>
        </Card>
      </Box>
    </PageLoading>
  )
}

export default Emails
